/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type WidgetSettingsContainer_user$ref = any;
type WidgetSettingsContainer_widget$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type WidgetsSettingsContainer_user$ref: FragmentReference;
export type WidgetsSettingsContainer_user = {|
  +widgets: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +name: ?string,
        +$fragmentRefs: WidgetSettingsContainer_widget$ref,
      |}
    |}>
  |},
  +$fragmentRefs: WidgetSettingsContainer_user$ref,
  +$refType: WidgetsSettingsContainer_user$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "WidgetsSettingsContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "WidgetSettingsContainer_user",
      "args": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "widgets",
      "storageKey": "widgets(first:20)",
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 20,
          "type": "Int"
        }
      ],
      "concreteType": "WidgetConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "WidgetEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Widget",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "id",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "name",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "FragmentSpread",
                  "name": "WidgetSettingsContainer_widget",
                  "args": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '36a8c3eb320cf43d9b81e25191abccc4';
module.exports = node;



// WEBPACK FOOTER //
// ./src/js/components/Settings/Widgets/__generated__/WidgetsSettingsContainer_user.graphql.js